import React from 'react';

export const PLFlagArt: React.FC = () => (
  <>
    <circle cx="10" cy="10" r="8.88889" fill="#F2F0F2" />
    <mask
      id="mask0_pl_flag"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="1"
      y="1"
      width="18"
      height="18"
    >
      <circle cx="10" cy="10" r="8.88889" fill="#FCFCFC" />
    </mask>
    <g mask="url(#mask0_pl_flag)">
      <rect
        x="1.11111"
        y="1.11111"
        width="17.7778"
        height="17.7778"
        fill="#F2F0F2"
      />
      <rect
        x="1.11111"
        y="10"
        width="17.7778"
        height="8.88889"
        fill="#D90026"
      />
    </g>
  </>
);

PLFlagArt.displayName = 'PLFlagArt';
